/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, type MutationsObject } from '@kp/js-model';
import { Adressen } from './Adressen';
import { Projektdaten } from './Projektdaten';
import { Beilage } from './Beilage';
import { Kontoinformation } from './Kontoinformation';
import { BaseModel } from '../BaseModel';
import { LiegenschaftData } from './LiegenschaftData';

export class Data extends BaseModel {
    adressen: Adressen | null = null;
    liegenschaften: LiegenschaftData[] = [];
    projektdaten: Projektdaten | null = null;
    beilagen: Beilage[] = [];
    kontoinformation: Kontoinformation | null = null;

    public mutations(): MutationsObject {
        return {
            adressen: (val: Adressen) => createModel(Adressen, val),
            liegenschaften: (val: LiegenschaftData[]) => val ? val.map((e) => createModel(LiegenschaftData, e)) : [],
            projektdaten: (val: Projektdaten) => createModel(Projektdaten, val),
            beilagen: (val: Beilage[]) => val ? val.map((e) => createModel(Beilage, e)) : [],
            kontoinformation: (val: Kontoinformation) => createModel(Kontoinformation, val),
        };
    }
}
